import Action from "./Action.vue";
import Actions from "./Actions.vue";
import Root from "./Root.vue";
import Save from "./Save.vue";

export default {
  Action,
  Actions,
  Root,

  Save,
};
